import { getM2MStorageHubDomain } from "./getM2MStorageHubDomain";
import { StorageClient } from "./lib/client";

class M2mStorageClient extends StorageClient {}

export type { M2mStorageClient };

/**
 * Get the connected storage client.
 * @param timeout
 * @default 5000
 */
const getStorage = async (timeout = 5000) => {
  const storage = await new Promise<M2mStorageClient>((resolve, reject) => {
    const rejectTimer = globalThis.setTimeout(function () {
      reject(
        new Error(
          "Timeout: M2mStorageClient could not connect. Please call m2mStorageClient.init() before using m2mStorageClient.",
        ),
      );
    }, timeout);

    const storage = globalThis.M2M_STORAGE;
    if (storage) {
      globalThis.clearTimeout(rejectTimer);
      resolve(storage);
    }

    const timer = globalThis.setInterval(() => {
      const storage = globalThis.M2M_STORAGE;
      if (storage) {
        globalThis.clearTimeout(rejectTimer);
        globalThis.clearInterval(timer);
        resolve(storage);
      }
    }, 200);
  });

  await storage.onConnect();

  return storage;
};

const initStorageClient = (options?: {
  env?: "development" | "production";
}) => {
  if (globalThis.M2M_STORAGE) {
    throw new Error(
      "M2mStorageClient already initialized. Do not call m2mStorageClient.init multiple times.",
    );
  }
  const storage = new M2mStorageClient(getM2MStorageHubDomain(options?.env));
  globalThis.M2M_STORAGE = storage;
};

export const m2mStorageClient = {
  init: initStorageClient,
  getStorage: getStorage,
};

export const M2M_AUTH_TOKEN_KEY = "M2M_APP_AUTH_TOKEN";

const getAuthTokenCache = () => {
  return globalThis.localStorage.getItem(M2M_AUTH_TOKEN_KEY);
};

const getAuthToken = async () => {
  try {
    const storage = await getStorage();
    const autuToken = (await storage.get(M2M_AUTH_TOKEN_KEY)) as string;
    return autuToken !== null && autuToken !== undefined && autuToken.length > 0
      ? autuToken
      : getAuthTokenCache();
  } catch (error) {
    console.warn(error);
    return getAuthTokenCache();
  }
};

const setAuthToken = async (token: string) => {
  globalThis.localStorage.setItem(M2M_AUTH_TOKEN_KEY, token);
  try {
    const storage = await getStorage();
    await storage.set(M2M_AUTH_TOKEN_KEY, token);
  } catch (error) {
    console.warn(error);
  }
};

const clearAuthToken = async () => {
  globalThis.localStorage.removeItem(M2M_AUTH_TOKEN_KEY);
  try {
    const storage = await getStorage();
    await storage.del(M2M_AUTH_TOKEN_KEY);
  } catch (error) {
    console.warn(error);
  }
};

export const m2mAuthTokenApi = {
  get: getAuthToken,
  getCache: getAuthTokenCache,
  set: setAuthToken,
  clear: clearAuthToken,
};
